import { createContext, type ReactNode, useContext } from "react";
import useProvideAuth from "../../auth/hooks/useProvideAuth";
import { checkifIsProUser } from "../utils/loginChecks";
import type { LicenseFeatures } from "~/generated/graphql";

export interface AuthInterface {
  signin: (token: string, cb: () => void) => void;
  signout: () => void;
  isLoggedIn: boolean;
  user: string | null;
}

type AuthContextInterface = AuthInterface & {
  isProUser: boolean;
  restrictions: {
    person?: {
      isTimeTracker?: boolean | null;
      isTimeTrackerAdmin?: boolean | null;
      hideKPIs?: boolean | null;
    } | null;
    featureLicenses?: LicenseFeatures;
  };
  isLoading: boolean;
};

const defaultAuth: AuthContextInterface = {
  signin: () => {},
  signout: () => {},
  isLoggedIn: false,
  isProUser: false,
  restrictions: { person: undefined, featureLicenses: undefined },
  isLoading: false,
  user: null,
};

export const authContext = createContext<AuthContextInterface>(defaultAuth);

export const ProvideAuth = ({ children }: { children: ReactNode }) => {
  const auth = useProvideAuth();
  const { isProUser, restrictions, isLoading } = checkifIsProUser();
  return (
    <authContext.Provider value={{ ...auth, isProUser, restrictions, isLoading }}>{children}</authContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(authContext);
};
